import React, { Fragment } from 'react'
import {Modal, Button } from "react-bootstrap"

const ModalConfirmaCierre = (props) => {
 	const { show, setShow, cierraVotacion, loader, votacion } = props
	return (
		<Modal
			show={show}
			onHide={() => setShow(false)}
			backdrop="static"
			keyboard={false}
			className="text-center"
		>
			<Modal.Header closeButton>
				<Modal.Title>Confirmar Cierre Proceso de Votación</Modal.Title>
			</Modal.Header>
			<Modal.Body className="px-2 py-4">
        <h2>{votacion.nombre}</h2>
        <h5>{votacion.unidad?.nombre}</h5>
				Usted está a punto de cerrar las votaciones, esto hará que nadie más pueda votar, está seguro?
			</Modal.Body>
			<Modal.Footer>
				<Button disabled={loader} variant="danger" block size="lg" onClick={()=>cierraVotacion(votacion.id)}>
					CERRAR PROCESO
				</Button>
				<Button
					variant="secondary"
					block
					disabled={loader}
					onClick={() => {
						setShow(false)
					}}
				>
					Volver
				</Button>
			</Modal.Footer>
		</Modal>
	)
}



export default ModalConfirmaCierre
